const key = 'https://deaf-2405-201-601b-884e-fc73-c212-8807-8045.ngrok-free.app'

export const logInAPIConfig = {
    logIn: key + '/api/v1/users/login',
    logInUsingToken:key+'/api/v1/users/loginWithToken',
}